import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { saveAs } from 'file-saver';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import LeadsStatusesDatabaseContext from '@/modules/leads_statuses/contexts/LeadsStatusesDatabaseContext';
import Button from '@/modules/common/components/Button';
import ButtonGroup from '@/modules/common/components/ButtonGroup';
import DownloadMenu from '@/modules/common/components/DownloadMenu';
import TextHelpField from '@/modules/common/components/TextHelpField';
import ContentBodyTop from '@/modules/common/components/ContentBodyTop';
import { withFetch } from '~/hocs/fetch';
import { withRouter } from '~/hocs/router';
import { base64toBlob } from '~/common';
import { actionSetDownloadingLeadsStatuses } from '@/modules/application/actions/downloading';

const Top = (props) => {
    // noinspection JSCheckFunctionSignatures
    const leadsStatusesDatabaseContext = useContext(LeadsStatusesDatabaseContext);
    const valuesFilter = leadsStatusesDatabaseContext.valuesFilter;
    const setValuesFilter = leadsStatusesDatabaseContext.setValuesFilter;

    const fetch = (format) => {
        props.setFetching(true);
        return props.fetch.get(`/api/leads_statuses/download/${format}/?${props.router.urlSearchParams.toString()}`)
            .then(({ok, data}) => {
                if (ok) {
                    const blob = base64toBlob(data.blob);
                    // noinspection JSUnresolvedVariable
                    saveAs(blob, data.file_name);
                }
            })
            .finally(() => {
                props.setFetching(false);
            });
    };

    const handleClickDownload = (popupState, format) => () => {
        popupState.close();
        fetch(format);
    };

    return (
        <ContentBodyTop
            left={<>
                {(props.leadsStatuses.length > 0)
                    ? <DownloadMenu fetching={props.fetching} onClickDownload={handleClickDownload}/>
                    : null
                }
            </>}
            right={
                <form id="form-filter" onSubmit={props.onSubmitFilter}>
                    <TextHelpField label="Список ID"
                                   value={valuesFilter.ids}
                                   onChange={(event) => setValuesFilter({...valuesFilter, ids: event.target.value})}
                    >
                        ID должны быть разделены пробелом
                    </TextHelpField>
                    <ButtonGroup>
                        {(props.isFiltered)
                            ? <Button onClick={props.onClickResetFilter}>Очистить фильтр</Button>
                            : null
                        }
                        <Button type="submit">Применить фильтр</Button>
                    </ButtonGroup>
                </form>
            }
        />
    );
};

Top.propTypes = {
    leadsStatuses: PropTypes.array.isRequired,
    isFiltered: PropTypes.bool.isRequired,
    onClickResetFilter: PropTypes.func.isRequired,
    onSubmitFilter: PropTypes.func.isRequired,
};

let Component = Top;
Component = withRouter(Component);
Component = withFetch(Component);

export default connect(
    (state) => ({
        fetching: state.downloading.leadsStatuses,
    }),
    (dispatch) => ({
        setFetching: bindActionCreators(actionSetDownloadingLeadsStatuses, dispatch),
    })
)(Component);
